// Supports `/{lang}/storage-resolver/...` links, which resolve to the actual storage file on click.
// See `src/server/controllers/storage-resolver.ts`.

export const STORAGE_RESOLVER_SEGMENT = 'storage-resolver';

const REGEX_STORAGE_RESOLVER_LINK = new RegExp(`^/(?:[a-z]{2}(?:-[a-z]{2})?/)?${STORAGE_RESOLVER_SEGMENT}/`);

export interface StorageResolverAction {
    action: 'resource-center-resource';
    slug: string;
}

export interface StorageResolverResource {
    file_id?: string | null;
    url?: string | null;
    is_gated?: boolean;
}

export function isStorageResolverLink(link: string): boolean {
    return REGEX_STORAGE_RESOLVER_LINK.test(link || '');
}

// `rest` is everything after `/{lang}/storage-resolver/`
export function parseStorageResolverPath(rest: string): StorageResolverAction | null {
    const [, slug] = (rest || '').match(/^resource-center\/resource\/([a-z0-9-]+)\/?$/) || [];

    if (slug) {
        return { action: 'resource-center-resource', slug };
    }

    return null;
}

// Mirrors the RC page logic, see `pageType` in resource-center-resource/component.vue
// and `pdfLink` in resource-ungated-asset.vue
export function getResourceFileUrl(resource: StorageResolverResource, storageBaseUrl: string): string | null {
    if (!resource || resource.is_gated) return null;

    if (resource.url) {
        return resource.url.includes('youtube') ? null : resource.url;
    }

    if (resource.file_id) {
        return `${storageBaseUrl}/downloads/${resource.file_id}`;
    }

    return null;
}
